import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import {
  AddedNote,
  DeletedNote,
  EditedNote,
  isNote,
  Note,
} from '../notes.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComponentChanges, FormModelControl } from '@bcl/design-system';
import { Claims } from 'src/app/authorization';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VoiceRecorder } from 'capacitor-voice-recorder';
import { Platform } from '@ionic/angular';
type NoteForm = {
  title: string | null;
  description: string | null;
};

@Component({
  selector: 'app-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss'],
})
export class NoteDialogComponent implements OnChanges, OnInit {
  public noteForm: FormGroup<FormModelControl<NoteForm>>;

  public action: string;
  public note?: Note;
  public initialDescription: string | null = null;
  public noteId?: string;

  public readonly claims = Claims;

  constructor(
    public dialogRef: MatDialogRef<NoteDialogComponent>,
    fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any | null,
    public platform: Platform
  ) {
    this.noteForm = fb.group({
      title: [null as string | null, Validators.required],
      description: null as string | null,
    });
    if (data) {
      this.note = data.note;
      this.noteForm.patchValue(data.note);
      this.action = data.action;
      this.initialDescription = data.note?.description ?? null;
      this.noteId = data.note?.id;
    }
    dialogRef.disableClose = true;
    dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.onEscape();
      }
    });
  }

  public async ngOnInit() {
    const { value } = await VoiceRecorder.requestAudioRecordingPermission();
  }

  public ngOnChanges(changes: ComponentChanges<NoteDialogComponent>): void {}

  public save(): void {
    if (!this.noteForm.valid) {
      this.noteForm.get('title')?.markAsTouched();
      return;
    }

    const formValue = this.noteForm.value;
    const note = {
      title: formValue.title ?? undefined,
      description: formValue.description ?? undefined,
      id: this.noteId,
    };
    this.dialogRef.close({ note, action: this.action });
  }
  public setDesc(desc: string) {
    this.noteForm.get('description')?.setValue(desc);
  }

  private onEscape(): void {
    this.dialogRef.close(false);
  }
}
